import BookIndex from "components/shared/book/list";
import SharedReactTable from "components/shared/reactTable";
import { dateTimeToView } from "helpers/date";
import { paths } from "helpers/paths";
import { DateColumnFilter, rowIndexColumn, SelectColumnFilter } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import React from "react";
import { Link } from "react-router-dom";
import { getAllCarsList } from "sources/admin";

class TrackerHistoryList extends BookIndex {
    get tableColumns() {
        return [
            rowIndexColumn,
            {
                Header: "ID",
                accessor: "id",
                width: 100,
                filterable: true,
                filterType: "int",
                Cell: ({ value }) => (
                    <Link to={paths.trackerHistoryItem(this.props.match.params.trackerId, value)}>{value}</Link>
                ),
            },
            {
                Header: "Номер",
                accessor: "number",
                id: "entityId",
                filterable: true,
                filterType: "select",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            url: getAllCarsList,
                            inputProps: { name: "truckId" },
                            propName: "number",
                        }}
                    />
                ),
            },
            {
                Header: "Дата привязки",
                accessor: "startedAt",
                sortable: true,
                filterable: true,
                filterType: "date",
                Filter: DateColumnFilter,
                Cell: ({ value }) => dateTimeToView(value, "DD.MM.YYYY HH:mm:ss"),
                CSVExport: ({ value }) => dateTimeToView(value, "DD.MM.YYYY HH:mm:ss"),
            },
            {
                Header: "Дата отвязки",
                accessor: "endedAt",
                sortable: true,
                filterable: true,
                filterType: "date",
                Filter: DateColumnFilter,
                Cell: ({ value }) => dateTimeToView(value, "DD.MM.YYYY HH:mm:ss"),
                CSVExport: ({ value }) => dateTimeToView(value, "DD.MM.YYYY HH:mm:ss"),
            },
        ];
    }

    close = () => {
        const { history, match } = this.props;
        history.push(paths.trackersShow(match.params.trackerId));
    };

    renderCreateButton = () => {
        const { history, match, onlyRoot } = this.props;
        const { isRoot } = this.props.roles;
        if (!isRoot && onlyRoot) {
            return null;
        }
        const props = {
            className: "btn btn-brand btn-sm",
            onClick: () => history.push(paths.trackerHistoryNew(match.params.trackerId)),
        };
        return <div {...props}>Добавление записи</div>;
    };

    renderListComponent = () => {
        const { getList, ...props } = this.props;
        return (
            <SharedReactTable
                {...props}
                getList={(params) => getList({ ...params, trackerId: parseInt(props.match.params.trackerId) })}
                columns={this.state.tableColumns}
            />
        );
    };
}

export default tableContainer(TrackerHistoryList, "trackerhistory");
